import React from 'react'

export default props => (
    <th {...props} className={props.acoes ? 'table-actions' : ''}
		style={{
			textAlign: props.alignRight ? 'right' : (props.alignCenter ? 'center' : 'left'),
			width: props.width,
			height: props.height,
			paddingLeft: 2,
			backgroundColor: props.backgroundColor,
			color: props.color
		}} >
		{props.children}
	</th>
)
